import { render } from "./BrandsDemoRequest.vue?vue&type=template&id=05319bc6&scoped=true"
import script from "./BrandsDemoRequest.vue?vue&type=script&lang=js"
export * from "./BrandsDemoRequest.vue?vue&type=script&lang=js"

import "./BrandsDemoRequest.vue?vue&type=style&index=0&id=05319bc6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05319bc6"]])

export default __exports__